export enum FINANCIAL_DOCUMENT_PRINT_TEMPLATE {
    STANDARD_NO_LOGO = 'standard_no_logo',
    STANDARD_LEFT_LOGO = 'standard_left_logo',
    STANDARD_RIGHT_LOGO = 'standard_right_logo',
}

export type BillingEntity = {
    id: string;
    tenant: {
        id: string;
        name: string;
    };
    created_at: string;
    modified_at: string;
    code: string;
    name: string;
    uic: string;
    address: string;
    tax_registration_number: string;
    representative: string;
    city: string;
    country: string;
    email: string | null;
    phone: string | null;
    invoice_prefix: string | null;
    invoice_footer: string | null;
    financial_document_print_template: FINANCIAL_DOCUMENT_PRINT_TEMPLATE;
    financial_document_print_logo: string | null;
    financial_document_print_color: string | null;
};
